import React, { useEffect, useState } from "react";
import { Download, FileSpreadsheet, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../api";

const downloadMonth = async (month, setBusy) => {
  setBusy(month);
  try {
    const r = await api.get(`/admin/reports/${month}.csv`, { responseType: "blob" });
    const url = URL.createObjectURL(r.data);
    const a = document.createElement("a");
    a.href = url;
    a.download = `british-supplements-${month}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  } catch {
    toast.error("Couldn't download that month, please try again");
  } finally {
    setBusy("");
  }
};

export const MonthlyReports = () => {
  const [months, setMonths] = useState([]);
  const [busy, setBusy] = useState("");

  useEffect(() => {
    api.get("/admin/reports/months").then((r) => setMonths(r.data)).catch(() => setMonths([]));
  }, []);

  return (
    <div className="mt-6 rounded-2xl border border-[#e6f0ea] bg-white p-5" data-testid="monthly-reports">
      <div className="mb-4 flex items-center gap-2">
        <FileSpreadsheet size={18} className="text-[#2D6A4F]" />
        <h2 className="font-display text-lg font-bold uppercase text-[#1B2a21]">Monthly Reports</h2>
        <span className="ml-auto text-xs text-[#6b7d72]">Opens in Excel or Google Sheets</span>
      </div>
      {months.length === 0 && <p className="text-sm text-[#6b7d72]">No orders yet.</p>}
      <div className="divide-y divide-[#eef4f0]">
        {months.map((m) => (
          <div key={m.month} className="flex items-center gap-3 py-3" data-testid={`report-row-${m.month}`}>
            <div className="flex-1">
              <p className="font-semibold text-[#1B2a21]">{m.label}</p>
              <p className="text-xs text-[#6b7d72]">{m.orders} orders · £{m.revenue.toLocaleString(undefined, { minimumFractionDigits: 2 })}</p>
            </div>
            <button
              onClick={() => downloadMonth(m.month, setBusy)}
              disabled={busy === m.month}
              data-testid={`report-download-${m.month}`}
              className="flex items-center gap-2 rounded-full border border-[#2D6A4F] px-4 py-2 font-display text-xs font-bold uppercase tracking-wide text-[#2D6A4F] transition-colors hover:bg-[#2D6A4F] hover:text-white disabled:opacity-50"
            >
              {busy === m.month ? <Loader2 size={14} className="animate-spin" /> : <Download size={14} />} Download
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};
